var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00390625 7.9098C-0.00390625 5.92208 1.45764 4.28951 3.36848 3.9156C3.76815 1.84921 5.64287 0.309082 7.8649 0.309082C10.3179 0.309082 12.3503 2.18833 12.4369 4.57761C14.2866 4.83355 15.7337 6.37021 15.7337 8.26239C15.7337 9.73579 14.8521 10.9976 13.5918 11.601C13.3184 11.7319 12.9905 11.6164 12.8596 11.3429C12.7287 11.0694 12.8442 10.7416 13.1177 10.6107C14.0267 10.1755 14.6357 9.28087 14.6357 8.26239C14.6357 6.97404 13.6543 5.87733 12.3373 5.67241C12.1796 6.38126 11.8469 7.02586 11.3874 7.56193C11.19 7.79212 10.8435 7.81876 10.6133 7.62143C10.3831 7.42409 10.3565 7.07752 10.5538 6.84733C10.9856 6.34366 11.264 5.71948 11.3278 5.03801C11.3371 4.93884 11.3418 4.83829 11.3418 4.73652C11.3418 2.91683 9.80463 1.40706 7.8649 1.40706C6.25381 1.40706 4.91858 2.45021 4.51399 3.84578C5.3374 3.90371 6.09725 4.19134 6.72318 4.64439C6.96879 4.82216 7.02379 5.16539 6.84601 5.411C6.66824 5.65661 6.32502 5.7116 6.07941 5.53383C5.55943 5.15746 4.91119 4.93292 4.20499 4.93292C4.10333 4.93292 4.00296 4.93757 3.90407 4.94664C2.31047 5.09273 1.09407 6.3796 1.09407 7.9098C1.09407 9.09169 1.81638 10.1252 2.88265 10.6052C3.15912 10.7297 3.28235 11.0547 3.15788 11.3312C3.03341 11.6077 2.70838 11.7309 2.43191 11.6064C1.00275 10.963 -0.00390625 9.55671 -0.00390625 7.9098Z",
    fill: "url(#paint0_linear_109_482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49718 8.54381C8.29494 8.19377 7.84723 8.07395 7.49719 8.27619C7.14715 8.47843 7.02734 8.92614 7.22958 9.27618L7.23286 9.28187C7.4351 9.6319 7.88281 9.75172 8.23285 9.54948C8.58289 9.34724 8.70271 8.89953 8.50047 8.54949L8.49718 8.54381Z",
    fill: "url(#paint1_linear_109_482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30206 10.7373C6.09982 10.3873 5.65211 10.2675 5.30207 10.4697C4.95203 10.6719 4.83221 11.1196 5.03445 11.4697L5.03774 11.4754C5.23998 11.8254 5.68769 11.9452 6.03773 11.743C6.38777 11.5408 6.50758 11.093 6.30534 10.743L6.30206 10.7373Z",
    fill: "url(#paint2_linear_109_482)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6923 10.7373C10.4901 10.3873 10.0424 10.2675 9.69232 10.4697C9.34228 10.6719 9.22246 11.1196 9.4247 11.4697L9.42799 11.4754C9.63022 11.8254 10.0779 11.9452 10.428 11.743C10.778 11.5408 10.8978 11.093 10.6956 10.743L10.6923 10.7373Z",
    fill: "url(#paint3_linear_109_482)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10693 12.9308C3.90469 12.5808 3.45698 12.461 3.10694 12.6632C2.7569 12.8655 2.63709 13.3132 2.83933 13.6632L2.84262 13.6689C3.04486 14.0189 3.49257 14.1387 3.84261 13.9365C4.19265 13.7343 4.31246 13.2865 4.11022 12.9365L4.10693 12.9308Z",
    fill: "url(#paint4_linear_109_482)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8874 12.9308C12.6852 12.5808 12.2375 12.461 11.8874 12.6632C11.5374 12.8654 11.4176 13.3132 11.6198 13.6632L11.6231 13.6689C11.8253 14.0189 12.2731 14.1387 12.6231 13.9365C12.9731 13.7343 13.093 13.2866 12.8907 12.9365L12.8874 12.9308Z",
    fill: "url(#paint5_linear_109_482)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49718 13.662C8.29495 13.312 7.84724 13.1921 7.4972 13.3944C7.14716 13.5966 7.02734 14.0443 7.22958 14.3944L7.23286 14.4001C7.4351 14.7501 7.88281 14.8699 8.23285 14.6677C8.58289 14.4654 8.70271 14.0177 8.50047 13.6677L8.49718 13.662Z",
    fill: "url(#paint6_linear_109_482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_109_482",
    x1: -1.70066,
    y1: 9.16621,
    x2: 17.8421,
    y2: 9.16621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ED34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E968A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackCloud);
export default __webpack_public_path__ + "static/media/crack-cloud.30be7679f7dc095ad7491c939d5117c9.svg";
export { ForwardRef as ReactComponent };